import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/compound/dropdown/PaymentYear";
 
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getDropDown=(id)=>{
        if(id){
            return  http.get(`${apiEndpoint}?payment_plan_ids=${id}`) 
        }else{
            return  http.get(`${apiEndpoint}`) 
        }
      }
 
}
